// src/core/Emitter.ts

export interface Emitter {
  on(event: string, handler: (...args: unknown[]) => void): void;
  off(event: string, handler: (...args: unknown[]) => void): void;
  emit(event: string, ...args: unknown[]): void;
}

export function createEmitter(): Emitter {
  const listeners = new Map<string, Set<(...args: unknown[]) => void>>();

  return {
    on(event, handler) {
      if (!listeners.has(event)) listeners.set(event, new Set());
      listeners.get(event)?.add(handler);
    },
    off(event, handler) {
      listeners.get(event)?.delete(handler);
    },
    emit(event, ...args) {
      const handlers = listeners.get(event);
      if (handlers) {
        for (const h of handlers) h(...args);
      }
    },
  };
}
